export default {"src":"/_next/static/media/Fer.349578ac.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};